export default "__VITE_PUBLIC_ASSET__fa23ca1a__"